import { Link } from "react-router-dom";
import "./creator.css";

/* Shown at /admin/creators to anyone who isn't a signed-in admin, instead of
   the site 404 — so an admin who simply isn't signed in yet knows what to do. */
export default function AdminCreatorsGate({ signedIn }) {
  return (
    <div className="cp">
    <div className="cp-wrap" style={{ minHeight: "100vh", display: "grid", placeItems: "center", textAlign: "center" }}>
      <div style={{ maxWidth: 420 }}>
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: ".18em", textTransform: "uppercase", color: "#e52324" }}>InstaPass Creators · Admin</div>
        <h1 style={{ fontSize: 32, fontWeight: 800, color: "#fff", margin: "10px 0 12px" }}>
          {signedIn ? "Admins only" : "Sign in as an admin"}
        </h1>
        <p style={{ color: "#bdbdbd", lineHeight: 1.5 }}>
          {signedIn
            ? "This account doesn't have admin access to the creator console."
            : "The creator console is for InstaPass admins. Sign in with your admin account to continue."}
        </p>
        {!signedIn && (
          <Link to="/login" state={{ from: "/admin/creators" }} className="cp-btn" style={{ display: "inline-block", marginTop: 18 }}>
            Sign in
          </Link>
        )}
      </div>
    </div>
    </div>
  );
}
